import { populate } from '@sly/core/constants/populate';
import AuthorIndexPage from 'sly/resourceCenter/pages/AuthorIndex';
import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';

export default AuthorIndexPage;

export async function getServerSideProps() {
  const { api, store } = createApiClient(apiEndpoints);
  try {
    await Promise.all(
      [
        api.getAuthor.asAction({
          populate: populate.authors,
          'filters[status]': 'active',
          sort: 'order',
        }),
        api.getResourceCenterCommonInfo.asAction(),
        api.getTopicHeader.asAction(),
      ].map(store.dispatch)
    );
  } catch (e) {
    console.error(e);
    return {
      notFound: true,
    };
  }
  return {
    props: {
      initialApiState: store.getState(),
    },
  };
}
